import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';
import TablaProductos from '../inventario/TablaProductos';
import { v4 as uuidv4 } from 'uuid';

import { Box, Divider, Typography, Grid, Button, Container, FormControl, TextField, Autocomplete,
            Paper, CircularProgress, Dialog, TableRow, TableCell, Table, TableContainer, DialogTitle, 
            DialogContent, DialogActions, 
            TableHead, TableBody, InputLabel, MenuItem, Select } from '@mui/material';

import { useTheme } from '@mui/material/styles'

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

// Styled components
import { getDate, usuarios} from '../../utils/functions/Utils';

import FormatoValeSalida from '../formatos/FormatoValeSalida';

function ValeSalida() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);
    const theme = useTheme();

    const [loading, setLoading] = useState(false);
    const [currentProduct, setCurrentProduct] = useState({clave: '', nombre: '', cantidad: 0, precioUnitario: 0, printImage: true, costoUnitario: 0 });
    const [tempProducts, setTempProducts] = useState([]);
    const [products, setProducts] = useState([]);
    const [cotizacion, setCotizacion] = useState({});
    const [modalEdit, setModalEdit] = useState(false);

    const [infoServicio, setInfoServicio] = useState({
        noReporte: '', equipo: '', marca: '', modelo: '', noSerie: '', noInventario: '', fechaReporte: DateTime.now(), hospital: '', area: '', observaciones: ''
    });

    const [showSalida, setShowSalida] = useState(false);
    const [salida, setSalida] = useState({elaboradoPor: '', solicitante: '', descripcion: '', fechaDeSolicitud: DateTime.now(),});
    const [solicitante, setSolicitante] = useState('');

    const [motivo, setMotivo] = useState('servicio');
    const [motivos, setMotivos] = useState(['servicio']);

    const [clientes, setClientes] = useState([]);
    const [cliente, setCliente] = useState('');

    const [open, setOpen] = useState(false);

    const [solicitado, setSolicitado] = useState(false);
    
    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    useEffect(() => {
        if (!['Admin', 'Tecnico', 'Secretaria', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Vale de salida de material';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } });
    }

    useEffect(() => {
        getData();
       return () => { 
        document.body.style.backgroundColor = theme.palette.background.default;
       }
   }, [])

    const getData = async () => {
        setLoading(true);
        try {
            let res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setMotivos(res.data.motivosSalida);
            }
            let tmpSalida = {
                elaboradoPor: auth.user.name,
                solicitante: ['Vendedor', 'Tecnico'].includes(auth.user.rol) ? auth.user.name : '',
                descripcion: `Vale de salida de almacén solicitado por ${salida.solicitante} para el reporte # ${infoServicio.noReporte}`,
                fechaDeSolicitud: DateTime.now(),
            }
            setSalida(tmpSalida);
            setSolicitante(tmpSalida.solicitante);
            // setSalida({
            //     elaboradoPor: auth.user.name,
            //     solicitante: '',
            //     descripcion: `Vale de salida de almacén solicitado por ${salida.solicitante} para el reporte # ${infoServicio.noReporte}`,
            //     fechaDeSolicitud: DateTime.now(),
            // })
            setInfoServicio({noReporte: '', hospital: ''})
            res = await axios.get('/api/hospitals/');
            if (res.status === 200) {
                setClientes(res.data);
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const getUuid = () => { return uuidv4() };

    const handleAddProduct = ({product}) => {
        let x = {};
        x.id = product._id;
        x.nombre = product.nombre;
        x.clave = product.clave;
        x.precioUnitario = product.precioUnitario;
        x.costoUnitario = product.costoUnitario;
        x.descripcion = product.descripcion;
        x.categoria = product.categoria;
        x.imagen = product.imagen;
        x.printImage = true;
        x.cantidad = 1;
        x.key = getUuid();
        setTempProducts(tempProducts => [...tempProducts, x]);
    }

    const handleOpen = () => {
        setOpen(true);
    };
    
      const handleClose = () => {
        setOpen(false);
    };

    const handleAddList = () => {
        setProducts(products => [...products, ...tempProducts]);
        setTempProducts([]);
        setOpen(false);
        document.title = `Vale de salida de almacen`;
    }

    useEffect(() => {
        updateCotizacion(products);
    }, [products])

    const updateCotizacion = (d) => {
        let subtotal = d.reduce(function (tot, arr) {
            return tot + arr.precioUnitario * arr.cantidad;
        }, 0);

        const iva = subtotal * 0.16;
        const total = subtotal + iva;

        setCotizacion({ subtotal: subtotal, iva: iva, total: total });
    }

    const handleDelete = (d, r) => {
        if (r < 2) {
            setProducts([]);
        } else {
            setProducts(products.filter(x => x.key !== d));
        }
    }

    const handleEdit = (d) => {
        setModalEdit(true);
        setCurrentProduct(d);
    }

    const handleCloseEdit = () => {
        setModalEdit(false);
        setCurrentProduct({clave: '', nombre: '', cantidad: 0, precioUnitario: 0, printImage: true, costoUnitario: 0 });
    }

    const handleUpdateRefaccion = (d, e) => {
        setModalEdit(false);
        setProducts(products.map(r => r.key === e ? d : r));
    }

    const renderSearchModal = () => {
        return(
            <Dialog
                fullWidth={true}
                maxWidth={'xxl'}
                open={open}
                className='exo2'
                scroll='paper'
                onClose={handleClose}>
                    <DialogTitle >Agregar productos</DialogTitle>
                    <DialogContent>
                        <Grid container >
                            <Grid item xs={12} lg={9} >
                                <TablaProductos height={500} cotizacion={true} onAddProduct={handleAddProduct} />
                            </Grid>
                            <Grid item xs={12} lg={3} style={{padding: '0px 8px'}}>
                                <Divider className='my-3' textAlign="left">
                                    <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos selecionados' className='text-bold' />
                                </Divider>
                                <TableContainer>
                                    <Table>
                                        <TableHead sx={{ borderBottom: 'solid 1px black' }}>
                                            <TableRow>
                                                <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Refacción</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                tempProducts.length > 0 ? tempProducts.map((ref, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell size='small' align='center' sx={{ fontSize: '1em' }}>{ref.clave}</TableCell>
                                                        <TableCell size='small' align='center' sx={{ fontSize: '1em' }}>{ref.nombre}</TableCell>
                                                    </TableRow>
                                                )) : <TableRow>
                                                    <TableCell size='small' align='center' colSpan={3} sx={{ fontSize: '1em' }}>No ha selecionado ninguna refacción</TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </DialogContent>
                <DialogActions>
                    <Button color='success' variant='contained' onClick={() => handleAddList()}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                    <Button color='warning' variant='contained' onClick={() => handleClose()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const renderProducts = () => {
        return(
            <>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Producto</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} onDoubleClick={() => handleEdit(ref)}>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                    <TableCell size='small' align='center'>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Button sx={{ minWidth: '110px' }} variant='contained' color='primary' className='m-1' onClick={() => handleEdit(ref)}>Editar &nbsp;&nbsp;<i className='fad fa-edit'></i></Button>
                                            <Button sx={{ minWidth: '50px' }} variant='contained' color='error' className='m-1' onClick={() => handleDelete(ref.key, products.length)}>&nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
            </>    
        )
    }

    const renderEditModal = () => {
        return(
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalEdit}
                className='exo2'
                scroll='paper'
                onClose={handleCloseEdit}>
                    <DialogTitle >Editar producto</DialogTitle>
                    <DialogContent>
                    {currentProduct ? 
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={4}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Clave" variant="outlined" value={currentProduct.clave} onChange={(e) => setCurrentProduct({ ...currentProduct, clave: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Producto" variant="outlined" multiline value={currentProduct.nombre} onChange={(e) => setCurrentProduct({ ...currentProduct, nombre: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                        <TextField label="Cantidad" variant="outlined" value={currentProduct.cantidad} onChange={(e) => setCurrentProduct({ ...currentProduct, cantidad: Number(e.target.value) })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div> : <div></div>}
                    <br />
                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdateRefaccion(currentProduct, currentProduct.key)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                    </Grid>
                    </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEdit()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleShowSalida = (e) => {
        e.preventDefault();
        setSalida({...salida, descripcion: `Vale de salida de almacén solicitado por ${solicitante} para el reporte # ${infoServicio.noReporte}`})
        setShowSalida(true);
    }

    const handleCloseSalida = () => {
        setShowSalida(false);
    }

    const handleSalida = async () => {
        if(products.length < 1) {
            setApiRes(state => { return { ...state, show: true, message: 'No ha seleccionado ningún producto', severity: 'warning' } });
        } else {
            const tmp = {
                elaboradoPor: salida.elaboradoPor, 
                solicitante: solicitante,
                estatus: 'Pendiente de entrega',
                descripcion: salida.descripcion,
                productos: products,
                cotizacion: cotizacion,
                fechaDeSolicitud: salida.fechaDeSolicitud,
                operacion: 'Servicio',
                servicio: true,
                cliente: cliente,
                infoServicio: { ...infoServicio, hospital: cliente},
                motivo: motivo,
            }
            try{
                const res = await axios.post('/api/deliveries', {delivery: tmp});
                if(res.status === 200) {
                    setApiRes(state => { return { ...state, show: true, message: 'Solicitud creada exitosamente', severity: 'success' } });
                    setSolicitado(true);
                    setShowSalida(false);
                }
            } catch (err) {
                setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al crear la solicitud, favor de intentarlo mas tarde', severity: 'error' } });
                console.log(err);
            }
        }
        
    }

    const modalSalida = () => {
        return(
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={showSalida}
                className='exo2'
                scroll='paper'
                onClose={handleCloseSalida}>
                    <DialogTitle  >Solicitar salida de productos de almacén</DialogTitle>
                    <DialogContent>
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Solicitante" variant="outlined" value={solicitante} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Fecha de solicitud" variant="outlined" value={getDate(salida.fechaDeSolicitud)}  />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                        <TextField label="Descripción" variant="outlined" value={salida.descripcion} onChange={(e) => setSalida({ ...salida, descripcion: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow hover >
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {products.map((ref, i) => (
                                                    <TableRow hover key={i}>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                        <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </div>
                    <br />
                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleSalida()}>&nbsp;Confirmar solicitud &nbsp;&nbsp;<i className='fad fa-badge-check' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                    </Grid>
                    </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseSalida()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const renderSolicitante = () => {
        if(auth.user.rol === 'Tecnico') {
            return(
                <Grid item xs={12} md={6} lg={4}>
                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                        <TextField disabled required label="Solicitante" variant="outlined" value={solicitante} />
                    </FormControl>
                </Grid>
            )
        } else {
            return(
                <Grid item xs={12} md={6} lg={4}>
                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                        <InputLabel id="select">Solicitante</InputLabel>
                        <Select
                            required
                            labelId="select"
                            value={solicitante}
                            label="Solicitante"
                            onChange={(e) => setSolicitante(e.target.value)}
                        >
                            {usuarios.map((usuario, i) => (
                                <MenuItem key={i} value={usuario}>{usuario}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            )
        }
    }

    return (
        <>
            <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

                {loading ?
                    <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                        <CircularProgress size='5em' color='primary' />
                    </Box> :
                    
                    <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                        <Container maxWidth='xl'>
                            <Box className='text-center' >
                                <Typography variant='h5' style={{ fontWeight: 700 }}>Vale de salida de productos de almacén</Typography>
                            </Box>

                            <Button size='small' variant='outlined' onClick={() => navigate('/inventario')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos de la solicitud' className='text-bold' />
                            </Divider>

                            <form onSubmit={(e) => handleShowSalida(e)}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                            <TextField required disabled label="Elaborado Por" variant="outlined" value={salida.elaboradoPor} />
                                        </FormControl>
                                    </Grid>
                                    {renderSolicitante()}
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                            <TextField required label="# Reporte/Cotizacion" variant="outlined" value={infoServicio.noReporte} onChange={(e) => setInfoServicio({ ...infoServicio, noReporte: e.target.value})} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} >
                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                            <Autocomplete
                                                disablePortal
                                                freeSolo={auth.user.rol === 'Tecnico' ? false : true}
                                                onInputChange={(event, newInputValue) => setCliente(newInputValue)}
                                                inputValue={cliente}
                                                aria-multiline='true'
                                                options={clientes.map((option) => option.name)}
                                                renderInput={(params) => <TextField required {...params} label='Unidad hospitalaria' />}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                            <InputLabel id="select">Motivo de salida</InputLabel>
                                            <Select
                                                disabled
                                                required
                                                labelId="select"
                                                value={motivo}
                                                label="Motivo de salida"
                                                onChange={(e) => setMotivo(e.target.value)}
                                            >
                                                {motivos.map((motivo, i) => (
                                                    <MenuItem key={i} value={motivo}>{motivo}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3} sx={{my: 1}}>
                                    <Grid item xs={12} md={4}>
                                        <Button variant="contained" color="secondary" onClick={handleOpen}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                                    </Grid>
                                    {solicitado ? 
                                        <Grid item xs={12} md={4}>
                                            <Button disabled variant="contained" color="secondary" >Los productos ya fueron solicitados en almacén &nbsp; <i className="fad fa-sign-out"></i></Button>
                                        </Grid> : 
                                        <Grid item xs={12} md={4}>
                                            <Button type='submit' variant="contained" color="secondary" >Solicitar productos &nbsp; <i className="fad fa-sign-out"></i></Button>
                                        </Grid>
                                    }
                                </Grid>
                            </form>
                            <br />


                            <Divider className='my-3' textAlign="center">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos' className='text-bold' />
                            </Divider>

                            {renderProducts()}
                        </Container>
                        <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
                    </Paper>
                }
            </Container>

            <Container maxWidth='xl'>
                <FormatoValeSalida data={{operacion: 'Servicio', noOrder: infoServicio.noReporte}} productos={products} cotizacion={cotizacion} infoServicio={infoServicio} salida={salida} cliente={cliente} solicitante={solicitante} userType={auth.user.rol}/>
            </Container>

            {renderSearchModal()}

            {renderEditModal()}

            {modalSalida()}
            
        </>
    );
}


export default ValeSalida;